import styles from './ToolForm.module.css';

const TOKEN_SPLIT_RE = /(\{\{[\s\S]*?\}\})/;

/** Renders template text with `{{...}}` tokens highlighted as injected values. */
export const HighlightedTemplate = ({ text }: { text: string }) => (
  <>
    {text.split(TOKEN_SPLIT_RE).map((part, index) =>
      part.startsWith('{{') && part.endsWith('}}') ? (
        <span key={index} className={styles.previewVar}>
          {part}
        </span>
      ) : (
        part
      ),
    )}
  </>
);
